(function() {
    // ... all your 'c' variable and 'd' function definitions are fine ...
    var c = { /* ... */ };
    function d(t) { /* ... */ }

    // This section is fine as it uses getElementById inside the loop
    Object.entries(c).forEach(([t, o]) => {
        let e = document.getElementById(`${t}-gallery`);
        o.forEach(r => e.appendChild(d(r)))
    });

    // --- MISTAKE AREA ---
    // The following date logic runs immediately on script load, not on DOM ready.
    // var n = new Date;
    // n.setUTCFullYear(n.getUTCFullYear());
    // ...
    // document.getElementById("utc-time").textContent=l; 
    // --------------------


    // --- FIX: Add your date script logic inside the DOMContentLoaded block ---
    document.addEventListener("DOMContentLoaded", function() {
        // --- Move the date calculation and placement in here ---

        var n = new Date();
        // The following lines with setUTC... don't change the value of 'n' meaningfully
        // but they are technically functional JS lines:
        n.setUTCFullYear(n.getUTCFullYear());
        n.setUTCMonth(n.getUTCMonth());
        n.setUTCDate(n.getUTCDate());
        n.setUTCSeconds(0);
        n.setUTCMilliseconds(0);
        
        // This is your correct formatting logic:
        var l = n.toISOString().replace("T", " ").replace(".000Z", " UTC");
        
        // Now the element with ID "utc-time" definitely exists:
        document.getElementById("utc-time").textContent = 'Today\'s date and time is: ' + l; 

        // ... rest of your parallax/scroll effect code ...
        let t = document.querySelector(".site-header")
        // ... etc ...
    });
})();